import { render, staticRenderFns } from "./LatestDiagResult.vue?vue&type=template&id=7ffec774&"
import script from "./LatestDiagResult.vue?vue&type=script&lang=js&"
export * from "./LatestDiagResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports